import { WarningTwoIcon } from '@chakra-ui/icons'
import { Collapse, Flex, Text } from '@chakra-ui/react'
import * as React from 'react'
import { useEffect, useState } from 'react'

export const CollapseWarning: React.FC<{
  warning?: string | null
  style?: React.CSSProperties
}> = ({ warning, style }) => {
  const [prevWarning, setPrevWarning] = useState<string | null>(null)
  useEffect(() => {
    if (warning) setPrevWarning(warning)
  }, [warning])

  return (
    <Collapse style={{ width: '100%' }} in={!!warning}>
      <Flex
        width="100%"
        fontSize="sm"
        py={2}
        px={2}
        gap={1.5}
        borderColor="orange.300"
        borderTopWidth="2px"
        borderBottomWidth="2px"
        bg="orange.100"
        align="center"
        style={style}>
        <WarningTwoIcon color="orange.500" boxSize={4} flexShrink={0} />
        <Text fontWeight={600} w="100%" fontFamily="Open Sans" lineHeight={1.1} color="orange.500">
          {prevWarning}
        </Text>
      </Flex>
    </Collapse>
  )
}
